import ActionCableVue from 'actioncable-vue'
import { cableConfig } from '@/utils/cable'

/**
 * ActionCable Vue 插件配置
 */
export default {
  install(app) {
    // 安装 ActionCable Vue 插件
    app.use(ActionCableVue, {
      debug: cableConfig.debug,
      debugLevel: cableConfig.debugLevel,
      connectionUrl: cableConfig.connectionUrl,
      connectImmediately: cableConfig.connectImmediately
    })

    console.log('ActionCable Vue 插件已安装')
  }
}

/**
 * 全局 ActionCable 方法
 */
export const cableMethods = {
  /**
   * 连接到 ActionCable 服务器
   */
  connectCable() {
    if (this.$cable) {
      this.$cable.connection.connect()
    }
  },

  /**
   * 断开 ActionCable 连接
   */
  disconnectCable() {
    if (this.$cable) {
      this.$cable.connection.disconnect()
    }
  },

  /**
   * 检查连接状态
   */
  isCableConnected() {
    return this.$cable ? this.$cable.connection.isOpen() : false
  },

  /**
   * 订阅频道
   */
  subscribeCable(params, channelName = null) {
    if (this.$cable) {
      this.$cable.subscribe(params, channelName)
    }
  },

  /**
   * 取消订阅频道
   */
  unsubscribeCable(channelName) {
    if (this.$cable) {
      this.$cable.unsubscribe(channelName)
    }
  },

  /**
   * 发送消息到频道
   */
  performCable(params) {
    if (this.$cable) {
      this.$cable.perform(params)
    }
  }
}
